import { JobType } from '../enum/job-title.enum';

export class Folder {
    public id: number;
    public name: string;
    public folderPermissions: JobType[];
}
